import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard } from 'swiper/modules';
import { Popover } from 'bootstrap';

let swiper; // wichtig: außerhalb, damit window.load später Zugriff hat

swiper = new Swiper(".projectSwiper", {
  modules: [Navigation, Pagination, Keyboard],
  loop: true,
  preloadImages: true,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 2,
  },
  watchSlidesProgress: true,

  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false
  },

  on: {
    init() {
      equalizeSwiperHeights(this); // <- "this" ist die Swiper-Instanz
    },
    imagesReady() {
      equalizeSwiperHeights(this);
    },
    resize() {
      equalizeSwiperHeights(this);
    },
    slideChange() {
      // Alle geöffneten Popovers schließen beim Swipen
      const popoverButtons = document.querySelectorAll('[data-bs-toggle="popover"]');
      popoverButtons.forEach(button => {
        const popoverInstance = Popover.getInstance(button);
        if (popoverInstance) {
          popoverInstance.hide();
        }
      });
      
      // Zusätzlich: alle sichtbaren Popover-Elemente im DOM schließen
      const visiblePopovers = document.querySelectorAll('.popover.show');
      visiblePopovers.forEach(popover => {
        popover.classList.remove('show');
        if (popover.parentNode) {
          popover.parentNode.removeChild(popover);
        }
      });
    }
  }
});

window.addEventListener('load', () => {
  if (swiper) equalizeSwiperHeights(swiper);
});

function equalizeSwiperHeights(swiperInstance) {
  // besser: die Slides aus der Instanz nehmen
  const slides = swiperInstance.slides;
  if (!slides || !slides.length) return;

  slides.forEach(slide => (slide.style.height = 'auto'));

  let maxHeight = 0;
  slides.forEach(slide => {
    const h = slide.offsetHeight;
    if (h > maxHeight) maxHeight = h;
  });

  slides.forEach(slide => {
    slide.style.height = maxHeight + 'px';
  });

  swiperInstance.update(); // <- sicher, weil Instanz vorhanden
}
